import { initialErrorState } from "views/common";

export function isValid(_) {
  const errors = initialErrorState();
  errors.entity = [];
  return errors;
}
